import React from 'react';
import uuid from 'uuid';
import { IDeal } from 'store/deals/types';
import { IDealEvaluationState, EEvaluationUnit } from 'store/deal-evaluation/types';
import { IFieldOptionState, IDealProduct } from 'store/field-options/types';
import { ProductItemsContainer } from 'components/deal-results/product-items/_common';
import ProductItem from 'components/deal-results/product-items/product-item';
import labels from 'constants/labels';

interface IProductItemsProps {
  dealEdit: IDeal;
  dealEvaluation: IDealEvaluationState;
  fieldOptions: IFieldOptionState;
}

export default ({ dealEvaluation, fieldOptions }: IProductItemsProps) => {
  let dealProducts: IDealProduct[] | undefined;

  const { deal: dealInEvaluation, selectedForecastType, selectedUnitType, loading } = dealEvaluation;
  if (dealInEvaluation) {
    dealProducts = dealInEvaluation.products;
  }
  const { products: availableProducts } = fieldOptions;
  const data = dealEvaluation[selectedForecastType];

  const pricePerUnitLabel =
    selectedUnitType === EEvaluationUnit.TON ? labels.currency.dollarsPerTon : labels.currency.centsPerPound;

  if (!data?.products || data.products.length === 0) {
    return null;
  }

  if (!dealProducts || !dealInEvaluation) {
    return null;
  }

  return (
    <ProductItemsContainer>
      {data.products.map((product, index: number) => (
        <ProductItem
          availableProducts={availableProducts}
          deal={dealInEvaluation}
          key={`results-product-${uuid()}`}
          id={`results-product-${index}`}
          index={index}
          loading={loading}
          pricePerUnitLabel={pricePerUnitLabel}
          productSummary={product}
          selectedUnitType={selectedUnitType}
        />
      ))}
    </ProductItemsContainer>
  );
};
